import httpClient from "@/_shared/http-client";
import { pagination } from "@/_shared/utils";
import urlBuilder from "./_urlBuilder";

const perform = async (tableName = "all", searchFilter = null) => {
  let results = [];
  let pagesCounter = 1;
  let totalRecords = 0;
  const url = urlBuilder.buildForItemsSearch(tableName, searchFilter);
  await httpClient.get(url).then(({ data }) => {
    pagesCounter = pagination.getPagesCounter(data.results);
    totalRecords = data.results;
    results = data.records
  });
  return { results, pagesCounter, totalRecords };
};

export const itemsSearchService = {
  perform,
};



// WEBPACK FOOTER //
// ./src/stock/api-services/itemsSearchService.js